import { usePermissions } from "components/context/permissionsContext";

export const useInvoicePermission = () => {
  const { userPermissions } = usePermissions();

  const hasInvoiceSavePermission = userPermissions.some(
    (item) =>
      item.module === "Invoice" &&
      item.controller === "Invoice" &&
      item.action === "Save" &&
      item.hasPermission
  );
  const hasInvoiceGetPermission = userPermissions.some(
    (item) =>
      item.module === "Invoice" &&
      item.controller === "Invoice" &&
      item.action === "Get" &&
      item.hasPermission
  );
  const hasInvoiceDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Invoice" &&
      item.controller === "Invoice" &&
      item.action === "Delete" &&
      item.hasPermission
  );
  const hasInvoiceSendEstEmailPermission = userPermissions.some(
    (item) =>
      item.module === "Invoice" &&
      item.controller === "Invoice" &&
      item.action === "SendEstimateEmail" &&
      item.hasPermission
  );
  const hasInvoiceSendEmailPermission = userPermissions.some(
    (item) =>
      item.module === "Invoice" &&
      item.controller === "Invoice" &&
      item.action === "SendInvoiceEmail" &&
      item.hasPermission
  );

  const InvoicePermissionProps = {
    hasInvoiceSavePermission,
    hasInvoiceGetPermission,
    hasInvoiceDeletePermission,
    hasInvoiceSendEstEmailPermission,
    hasInvoiceSendEmailPermission,
  };

  return {
    InvoicePermissionProps,
  };
};
